<template>
  <div class="d-flex flex-column agent-chat">
    <div class="chat-scroll flex-grow-1" ref="scroll">
      <div v-if="!messages.length" class="d-flex flex-column align-center justify-center text-center empty-state">
        <app-icon class="text-medium-emphasis mb-2" size="65">chat_bubble</app-icon>
        <h3 class="mt-5 mb-2 font-weight-regular">Peça à IA para revisar o documento</h3>
        <p class="text-medium-emphasis">Selecione uma das sugestões abaixo ou digite uma instrução.</p>
      </div>

      <template v-for="message in messages">
        <AgentUserMessage v-if="message.role === 'user'" :key="message.id" :text="message.text" />
        <div v-else :key="message.id + '-a'">
          <AgentAssistantMessage :text="message.text" :pending="message.pending" :error="message.error" />
          <div v-if="message.warnings && message.warnings.length" class="agent-warnings mb-3 ml-9">
            <div v-for="(warning, index) in message.warnings" :key="index" class="d-flex align-center">
              <app-icon size="14" class="mr-1">warning</app-icon>
              {{ warning }}
            </div>
          </div>
          <AgentProposalMessage
            v-for="action in message.actions"
            :key="action.id"
            :action="action"
            @decide="$emit('decide', $event)"
          />
        </div>
      </template>
    </div>

    <v-card-actions class="d-flex w-100 flex-column pt-2 flex-shrink-0">
      <div v-if="disabled" class="credits-warning text-caption d-flex align-center px-1 mb-2">
        <app-icon size="16" class="mr-1">warning</app-icon>
        Você atingiu o limite de créditos de I.A. deste mês.
      </div>
      <div v-else-if="creditsRemaining !== null" class="text-caption text-medium-emphasis px-1 mb-2">
        {{ creditsRemaining }} {{ creditsRemaining === 1 ? 'crédito restante' : 'créditos restantes' }} este mês
      </div>
      <div class="d-flex w-100 flex-wrap pb-2">
        <v-chip
          v-for="suggestion in suggestions"
          :key="suggestion"
          @click="$emit('use-suggestion', suggestion)"
          :disabled="loading || disabled"
          class="mx-1 mb-1"
        >
          {{ suggestion }}
        </v-chip>
      </div>
      <div class="ai-input-container">
        <v-textarea
          :value="instructions"
          @input="$emit('update:instructions', $event)"
          :readonly="loading || disabled"
          placeholder="Digite uma mensagem..."
          outlined
          dense
          hide-details
          auto-grow
          rows="1"
          class="ai-textarea"
          @keydown.enter.exact.prevent="$emit('send')"
        >
          <template v-slot:append>
            <v-btn icon small color="primary" :disabled="!canSend" @click="$emit('send')" :loading="loading">
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </template>
        </v-textarea>
      </div>
    </v-card-actions>
  </div>
</template>

<script>
import AgentUserMessage from './messages/AgentUserMessage.vue'
import AgentAssistantMessage from './messages/AgentAssistantMessage.vue'
import AgentProposalMessage from './messages/AgentProposalMessage.vue'

export default {
  name: 'AiAgentChat',
  components: { AgentUserMessage, AgentAssistantMessage, AgentProposalMessage },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    instructions: {
      type: String,
      default: null,
    },
    creditsRemaining: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canSend() {
      return !this.loading && !this.disabled && !!this.instructions && this.instructions.length > 0
    },
  },
  updated() {
    this.scrollToBottom()
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.scroll

        if (el) {
          el.scrollTop = el.scrollHeight
        }
      })
    },
  },
}
</script>

<style scoped>
.agent-chat {
  height: 100%;
}

.chat-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  min-height: 300px;
  scrollbar-width: thin;
  scrollbar-color: #e4e4e4 transparent;
}

.empty-state {
  min-height: 250px;
}

.ai-input-container {
  width: 100%;
  padding: 0 16px;
}

.credits-warning {
  color: #b45309;
}

.agent-warnings {
  color: #b45309;
  font-size: 12px;
}

.ai-textarea ::v-deep .v-input__append-inner {
  align-self: flex-end;
  margin-bottom: 6px;
}
</style>
